import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { getValidHtmlAttributes } from '@bibliocommons/utils-html';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './FullScreenOverlayBody.scss';

export default function FullScreenOverlayBody({ className, children, tagName: Tag, ...props }) {
  return (
    <Tag {...getValidHtmlAttributes(props, Tag)} className={cn('cp-full-screen-overlay-body', className)}>
      {children}
    </Tag>
  );
}

FullScreenOverlayBody.defaultProps = {
  tagName: 'div'
};

FullScreenOverlayBody.propTypes = {
  className: PropTypes.string,
  tagName: PropTypes.string,
  children: childrenShape
};
